import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { fetchTvShows } from './actions';
import TvShowListPage from './shows/TvShowListPage';
import TvShowEditPage from './shows/TvShowEditPage';
import TvEpisodeEditPage from './episodes/TvEpisodeEditPage';
import Loading from '../common/components/Loading';

class TV extends Component {
  componentDidMount() {
    const { dispatch, showsLoaded } = this.props;

    if (!showsLoaded) {
      dispatch(fetchTvShows());
    }
  }
  render() {
    const { match, showsLoaded } = this.props;

    if (!showsLoaded) {
      return <Loading />;
    }

    return (
      <Switch>
        <Route exact path={`${match.path}/shows`} component={TvShowListPage} />
        <Route exact path={`${match.path}/shows/:id`} component={TvShowEditPage} />
        <Route exact path={`${match.path}/shows/:showId/episodes/:id`} component={TvEpisodeEditPage} />
        <Redirect to={`${match.path}/shows`} />
      </Switch>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    showsLoaded: state.tv.shows.get('loaded'),
  };
};

export default connect(mapStateToProps)(TV);



// WEBPACK FOOTER //
// ./src/tv/Tv.js